import React from "react";
import WholeLineContainer from "../../../../../../../Components/ReportFormTemplate/WholeLineContainer";
import CustomRadioGroup from "../../../../../../../Components/CustomInputs/CustomRadioGroup";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../../../../redux/store/store";
import { shouldRenderSpecField } from "../../../../../../../redux/reducers/visibilityMatrixesReducer";
import { handleShowErrorMessage } from "../../../../../../../redux/reducers/claimFieldErrorsReducer";
import { updateFirstStepGeneralFields } from "../../../../../../../redux/reducers/claimReducer";
import { useScrollToTopErrorInput } from "../../../../../../../CustomHooks/useScrollToTopErrorInput";

const IsIntoxicatedOrInfluencedOfAlcoholField: React.FC = () => {
   const fieldNameLowerCase = "isIntoxicatedOrInfluencedOfAlcohol";
   const fieldNameUpperCase =
      fieldNameLowerCase.charAt(0).toUpperCase() + fieldNameLowerCase.slice(1);
   const dispatch = useDispatch();

   const fieldValue = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase[fieldNameLowerCase]
   );

   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );

   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );

   const { selectedTypeOfClaims } = useSelector(
      (state: StoreType) => state.claimState
   );

   const fieldHeading = () => {
      const isInjuryBeingReported = selectedTypeOfClaims.some(
         (claim: string) => claim === "injury"
      );
      const isPermConsequencesBeingReported = selectedTypeOfClaims.some(
         (claim: string) => claim === "permconsequences"
      );
      const isDeathBeingReported = selectedTypeOfClaims.some(
         (claim: string) => claim === "death"
      );
      if (
         isDeathBeingReported &&
         (isInjuryBeingReported || isPermConsequencesBeingReported)
      ) {
         return "Došlo k úrazu/úmrtí pod vlivem alkoholu nebo omamných látek?";
      } else if (isInjuryBeingReported || isPermConsequencesBeingReported) {
         return "Došlo k úrazu pod vlivem alkoholu nebo omamných látek?";
      } else {
         return "Došlo k úmrtí pod vlivem alkoholu nebo omamných látek?";
      }
   };

   const ref = React.useRef<HTMLDivElement>(null);
   useScrollToTopErrorInput(ref, fieldNameUpperCase);
   return (
      <WholeLineContainer
         dependencyValue={shouldRenderSpecField(
            "GeneralFields",
            fieldNameUpperCase,
            visibilityMatrixes
         )}
      >
         <CustomRadioGroup
            heading={fieldHeading()}
            firstLabel="Ano"
            secondLabel="Ne"
            value={fieldValue}
            updateFunc={(e: any) => {
               dispatch(
                  updateFirstStepGeneralFields({
                     value: e === "true" ? true : false,
                     field: fieldNameLowerCase,
                  })
               );
            }}
            validationText={handleShowErrorMessage(
               fieldNameUpperCase,
               claimFieldErrorsMessages
            )}
            inputRef={ref}
         />
      </WholeLineContainer>
   );
};

export default IsIntoxicatedOrInfluencedOfAlcoholField;
